import { createContext } from "react";
export const SEOContext = createContext(null);